import React, { useEffect, useState } from 'react';
import { useHistory, useParams } from "react-router-dom";
import { FindocsService } from "../../services/dao/findocs-service";
import { Auth } from "aws-amplify";
import { Box, CircularProgress } from "@mui/material";
import FindocDetailsCard from "./components/findoc-details-card";

const findocsService = new FindocsService();

export default function FindocDetailsScreen() {
    const [findoc, setFindoc] = useState(null);
    const { findocId } = useParams();

    useEffect(() => {
        findocsService.getFindoc(findocId).then(r => { if (r?.body) setFindoc(r.body); });
    }, [findocId]);

    if (!findoc) return <Box sx={{ display: 'flex', justifyContent: 'center', pt: 10 }}><CircularProgress /></Box>;

    return <FindocDetailsCard findoc={findoc} />;
}
